/* istanbul ignore file */
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PreInitSettingsService } from 'src/app/core/services/settings/pre-init-setting.service';
import { IPayment } from 'src/app/model/billing/IPayment';

@Injectable({
  providedIn: 'root'
})
export class BillingService {
  middlewareUrl: string;
  billingPath: string;
  subscriptionKey: string;

  constructor(
    private http: HttpClient,
    private preInitSettingsService: PreInitSettingsService,
  ) {
    this.middlewareUrl = this.preInitSettingsService.getSettings().middleWare.middlewareUrl;
    this.billingPath = this.preInitSettingsService.getSettings().middleWare.billingPath;
    this.subscriptionKey = this.preInitSettingsService.getSettings().middleWare.subscriptionKey;
  }

  getPaymentHistory(contractId: string, programCode: string, clientId: string, trackingId: string, associateNumber: string) {
    const httpOptions = {
      params: new HttpParams()
        .set('contractId', contractId)
        .set('programCode', programCode)
        .set('clientId', clientId)
        .set('trackingId', trackingId)
        .set('associateNumber', associateNumber)
    };

    return this.http.get<IPayment[]>(`${this.middlewareUrl}${this.billingPath}paymenthistory`, httpOptions);
  }
}
